import { SIDE_NAV_DARK, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'SamacWMS';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const WSS_BASE_URL = env.WSS_ENDPOINT_URL

export const APP_PREFIX_PATH = '';
export const SYSTEM_PREFIX_PATH = '/system';
export const CONFIG_PREFIX_PATH = '/config';
export const UTILITIES_PREFIX_PATH = '/utilities';
export const PERMISSIONS_PREFIX_PATH = '/permissions';
export const AUTH_PREFIX_PATH = '/auth';
export const POOL_PREFIX_PATH = '/pool';

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_DARK,
	locale: 'it',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR
};
